const _ = require('lodash');

/**
 * Validates a value to check if it already exists in an array.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name min
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input or data source is not provided
  if (value === undefined || value === null || value === '' || (context && (!context.dataSource || !context.property))) {
    return Promise.resolve(null);
  }

  // check if item already exists
  let itemExists = false;
  if (context.compareTwoArrays) {
    // if data source is array and the value is array as well.
    const valueToCompare = value.map((x) => x.toLowerCase());
    itemExists = context.dataSource
      .find((x) => {
        const dataSource = (_.get(x, context.property) || []).map((y) => y.toLowerCase());
        return _.intersection(dataSource, valueToCompare).length > 0
          && !(context.currentId && context.idKey && (_.get(x, context.idKey) || '') === context.currentId);
      });
  } else if (context.valueInArray) {
    // if you need to check if value is in the array
    itemExists = context.dataSource
      .find((x) => (((_.get(x, context.property) || [])
        .map((y) => y.toLowerCase()))
        .indexOf(value.toLowerCase()) > -1)
        && !(context.currentId && context.idKey && (_.get(x, context.idKey) || '') === context.currentId));
  } else {
    // if data source and value are the same
    itemExists = context.dataSource
      .find((x) => (_.get(x, context.property) || '').toLowerCase() === value.toLowerCase()
        && !(context.currentId && context.idKey && (_.get(x, context.idKey) || '') === context.currentId));
  }

  return Promise.resolve(itemExists ? 'unique' : null);
}

module.exports = validate;
